


















































































































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';

import IEdit from '@/components/icons/IEdit.vue'
import ITrash from '@/components/icons/ITrash.vue'
import ICheck from '@/components/icons/ICheck.vue'
import IClose from '@/components/icons/IClose.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    'i-edit': IEdit,
    'i-trash': ITrash,
    'i-check': ICheck,
    'i-close': IClose,
  },
  name: "AddQuestionForm"
})
export default class AddQuestionForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @surveys.Getter('stateCurrentSurvey') protected stateCurrentSurvey:any

  TYPE_TEXT:any = this.$t('survey.types.typeText')
  TYPE_SELECT:any = this.$t('survey.types.typeSelect')
  SPECIFY_SINGLE:any = this.$t('survey.types.specifySingle')
  SPECIFY_MULTI:any = this.$t('survey.types.specifyMulti')
  checkFreeType: string | undefined = 'free_text_input'

  other:boolean = false
  answer:any = {
    value: '',
    includeQuestions: [],
    isEdit: false,
  }
  currentAnswer:any = {}
  question:any = {
    answerTitle: '',
    answers: [],
    important: false,
    text: '',
    type: 'select',
    specify: 'single'
  }
  otherType:string = 'free_text_input'

  @Watch('fullDialogShow')
  setQuestion() {
    if(!this.fullDialogShow) {
      this.question = {
        answerTitle: '',
        answers: [],
        important: false,
        text: '',
        type: 'select',
        specify: 'single'
      }
      this.other = false
      this.otherType = 'free_text_input'
    }
  }

  get typeList() {
    return [
      {id: 'text', text: this.$t('survey.types.typeText')},
      {id: 'select', text: this.$t('survey.types.typeSelect')}
    ]
  }

  get specifyListSelect() {
    return [
      {id: 'single', text: this.$t('survey.types.specifySingle')},
      {id: 'multi', text: this.$t('survey.types.specifyMulti')}
    ]
  } 

  get specifyItems() {
    return [
      { id: 'text', text: this.$t('surveys.form.text') },
      { id: 'number', text: this.$t('surveys.form.number') }
    ]
  }

  get items() {
    return [
      { id: 'free_text_input', text: this.$t('surveys.form.text') },
      { id: 'free_number_input', text: this.$t('surveys.form.number') }
    ]
  }

  addAnswer() {
    this.question.answers.push({...this.answer, order: this.question.answers.length + 1});
    this.answer.value = ''
    this.answer.isEdit = false
  }

  editAnswer(answer:any) {
    answer.isEdit = true
    this.currentAnswer = {...answer}
  }

  changeAnswer(answer:any) {
    answer.isEdit = false
    answer.value = this.currentAnswer.value
  }

  changeType() {
    if(this.question.type == 'text') {
      this.question.specify = 'text'
    } else {
      this.question.specify = 'single'
    }
  }
 
  cancelEditAnswer(answer:any) {
    answer.isEdit = false
  }

  deleteAnswer(answer:any) {
    this.question.answers = this.question.answers.filter((a:any) => {
      return a.order != answer.order
    })
    this.question.answers.forEach((answer:any, index:number) => {
      answer.order = index
    }) 
  }

  save() {
    this.question.answerTitle = this.question.type == 'text' ? this.$t('surveys.form.textAnswer') :
                                this.question.specify == 'single' ? this.$t('surveys.form.oneAnswer') : this.$t('surveys.form.someAnswer')
    this.question.isNew = true
    if(this.question.type == 'text') {
      this.question.answers = [{
        value: '',
        includeQuestions: [],
        order: 0,
        type: 'regular'
      }]
    }
    if(this.other) {
      this.question.answers.unshift({
        order: 0, 
        type: this.otherType, 
        includeQuestions: [],
        value: ''
      })
    }
    this.stateCurrentSurvey.survey.questions.push(this.question)
    this.SetFullDialogShow(false)
  }
  

}
